import { useEffect } from 'react';
import { RouterProvider } from '@calvear/react-spa-routerizer';
import { StoreProvider } from '@calvear/react-redux';
import { ToastContainer } from 'react-toastify';
import { useUI, IntlProvider } from 'modules/ui';
import AppRouter, { routes } from 'routes';
import store from 'store';

/**
 * App container.
 *
 * Here occur the initialization
 * and localization of some libs.
 *
 * @returns {React.ReactElement} App container.
 */
export default function App()
{
    // loads UI theme stylesheets.
    useUI();

    useEffect(() =>
    {
        require('styles/app.scss');
    }, []);

    return (
        <IntlProvider>
            <RouterProvider routes={ routes }>
                <StoreProvider store={ store }>
                    <AppRouter />
                </StoreProvider>

                <ToastContainer />
            </RouterProvider>
        </IntlProvider>
    );
}
